// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../config/styles';

const styles = theme => ({
  mainContainer: {
    flexBasis: 320,
    [theme.breakpoints.down(1025)]: {
      marginTop: 20,
      flexBasis: '50%',
    },
    [theme.breakpoints.down(600)]: {
      marginTop: 40,
      flexBasis: '100%',
    },
  },
  mainInnerContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleContainer: {
    minHeight: 126,
    height: '100%',
    margin: 14,
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down(1800)]: {
      minHeight: 100,
    },
    [theme.breakpoints.down(1600)]: {
      minHeight: 90,
    },
    [theme.breakpoints.down(1368)]: {
      minHeight: 70,
    },
    [theme.breakpoints.down(600)]: {
      minHeight: 20,
    },
  },
  descriptionContainer: {
    padding: '0 18px',
  },
  titleText: {
    textAlign: 'center',
    lineHeight: 1.2,
    color: GlobalStyles.color.COLOR_SECONDARY,
    fontSize: GlobalStyles.fonts.FONT_SIZE_EXTRA_MAX,
    fontFamily: GlobalStyles.fonts.FONT_MONTSERRAT_BOLD,
    [theme.breakpoints.down(1800)]: {
      fontSize: 32,
    },
    [theme.breakpoints.down(1368)]: {
      fontSize: 28,
    },
    [theme.breakpoints.down(1025)]: {
      padding: '0 120px',
    },
    [theme.breakpoints.down(920)]: {
      padding: '0 40px',
    },
  },
  descriptionText: {
    textAlign: 'center',
    fontSize: GlobalStyles.fonts.FONT_SIZE_MAX,
    fontFamily: GlobalStyles.fonts.FONT_MONTSERRAT_MEDIUM,
    [theme.breakpoints.down(1800)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    },
    [theme.breakpoints.down(1368)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    },
    [theme.breakpoints.down(1025)]: {
      padding: '0 80px',
    },
    [theme.breakpoints.down(920)]: {
      padding: '0 40px',
    },
  },
  image: {
    height: 124,
    [theme.breakpoints.down(1600)]: {
      height: 'calc(124px / 1.2)',
    },
    [theme.breakpoints.down(1025)]: {
      height: 'calc(124px / 1.4)',
    },
  }
});

export default styles;
